import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopBar from "../topbar/TopBar.js";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from 'dompurify';
import SearchWithAPI from "../common/searchbox/searchbox.js";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import AsyncSelect from "react-select/async";
import { ReactComponent as BackIcon } from "../../assets/svg/nav-prev.svg";
import { createTemplateApi, createWhatsappTemplateApi, getTemplateDetailsApi, updateTemplateApi } from "../modal-dialog/setup-api.js";
import { ReactComponent as UploadIcon } from "../../assets/svg/upload_btn.svg";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export const TemplateCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const navigate = useNavigate();
  const location = useLocation();
  const { id, } = location.state || {};
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "0px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "618px",
      height: "100vh",
      overflowY: "auto",
    },
  };


  const [loading, setLoading] = useState(false);
  const [templateCode, setTemplateCode] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [status, setStatus] = useState("Active");
  const [typeOption, setTypeOption] = useState(null);
  const [mediumOption, setMediumOption] = useState(null);
  const [title, setTitle] = useState("");
  const [headerType, setHeaderType] = useState("");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);


  const [contentValue, setContentValue] = useState('');

  useEffect(() => {
  }, []);


  const [validations, setValidations] = useState({
    "code": "",
    "name": "",
    "medium": "",
    "status": "",
    "type": "",
    "template": "",
    'title': "",
  });
  function convertTo12Hour(time24) {
    const [hour, minute] = time24.split(':');
    const h = parseInt(hour);
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 || 12; // convert 0 to 12
    const formattedHour = hour12.toString().padStart(2, '0');
    const formattedMinute = minute.toString().padStart(2, '0');
    return `${formattedHour}:${formattedMinute} ${suffix}`;
  }
  useEffect(() => {
    if (id != null) {
      getTemplateDetails()
    }
  }, []);

  const getTemplateDetails = async () => {
    try {
      const response = await getTemplateDetailsApi(id);
      if (response.status === true) {
        console.log(response)
        var templateDetails = response.template;
        console.log(templateDetails)
        setTemplateCode(templateDetails.code ?? '')
        setTemplateName(templateDetails.name ?? '')
        setStatus(templateDetails.status === true ? 'Active' : 'InActive')
        setTypeOption({ 'value': templateDetails.type ?? '', 'label': templateDetails.type ?? '', })
        setMediumOption({ 'value': templateDetails.medium ?? '', 'label': templateDetails.medium ?? '', })
        setTitle(templateDetails.title ?? '')
        setContentValue(templateDetails.template ?? '')

      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const submitTemplate = async () => {

    const dataBeforeSanitize = {
      "code": templateCode,
      "name": templateName,
      "medium": mediumOption != null ? mediumOption.value : "",
      "status": status === 'Active' ? true : false,
      "type": typeOption != null ? typeOption.value : "",
      "template": contentValue,
      'title': title,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === 'assignee') {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (id == null) {
      const response = await createTemplateApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true) {

          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          navigate(-1);
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "medium": "",
            "status": "",
            "type": "",
            "template": "",
            'title': "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateTemplateApi(dataAfterSanitize, id);
      if (response.status === 200) {
        if (response.data.status === true) {

          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          navigate(-1);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "medium": "",
            "status": "",
            "type": "",
            "template": "",
            'title': "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  const handleMediumDropdownChange = (option) => {
    console.log(option)
    setContentValue("")
    setMediumOption(option)
  };

  const handleTypeDropdownChange = (option) => {
    console.log(option)
    setTypeOption(option)
  };

  return (<Container fluid className="main-container">
    <div style={{ width: "100vw" }}>
      <TopBar />
      <Row sm={12} className="main-row">
        <Col className="mx-2 " sm={12} style={{ padding: "16px" }}>
          <Row sm={12}>
            <Col sm={6} md={9}>
              <div className="style-justify-start">
                <div
                  onClick={() => {
                    navigate(-1);
                  }}
                  style={{
                    cursor: "pointer",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <BackIcon />
                </div>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#21272C",
                  }}
                >
                  Add template
                </span>
              </div>
            </Col>
            <Col sm={6} md={3}>
              <div className="style-justify-end" style={{ gap: "8px" }}>
                <div
                  className="cancel_btn"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#21272C",
                    }}
                  >
                    Cancel
                  </div>
                </div>
                <div
                  className="success_btn"
                  onClick={() => {
                    submitTemplate()
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#FFFFFF",
                    }}
                  >
                    Submit
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <div className="card-view mt-2">
            <Row className="">
              <Col xs={12} sm={12} lg={8}>

                <div className="card-title">Template details</div>
                <Row style={{ display: "flex" }}>
                  <Col xs={12} sm={12} md={6} >
                    <div className="field-title">
                      Code<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter here"
                      className="input-field mt-2 w-100"
                      value={templateCode}
                      onChange={(event) => {
                        setTemplateCode(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.code}</span>
                  </Col>
                  <Col xs={12} sm={12} md={6} >
                    <div className="field-title">
                      Name<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter here"
                      className="input-field mt-2 w-100"
                      value={templateName}
                      onChange={(event) => {
                        setTemplateName(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.name}</span>
                  </Col>
                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <div className="field-title mb-2">
                      Type<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <SearchWithAPI onDropdownChange={handleTypeDropdownChange} apiUrl={apiUrl + "alert_config"} params={{}} placeholder={"Select"} selectedOption={typeOption} />
                    <span className="field-error" >{validations.type}</span>
                  </Col>
                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <div className="field-title">
                      Status
                    </div>
                    <select className="select3 w-100 input-field mt-2" id="status" value={status} onChange={(event) => { setStatus(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>

                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>
                    <span className="field-error" >{validations.status}</span>
                  </Col>
                  <Col xs={12} sm={12} md={6} className="mt-2">
                    <div className="field-title mb-2">
                      Medium<span style={{ color: '#FF4444' }}>*</span>
                    </div>
                    <SearchWithAPI onDropdownChange={handleMediumDropdownChange} apiUrl={apiUrl + "get_template_medium"} params={{}} placeholder={"Select"} selectedOption={mediumOption} />
                    <span className="field-error" >{validations.medium}</span>
                  </Col>
                  {mediumOption !== null && mediumOption.value === "app-notification" && (<Col xs={12} sm={12} md={6} className="mt-2">
                    <div className="field-title">
                      Title
                    </div>
                    <input
                      type="text"
                      placeholder="Enter here"
                      className="input-field mt-2 w-100"
                      value={title}
                      onChange={(event) => {
                        setTitle(event.target.value); // Update state with input value
                      }}
                    />
                    <span className="field-error" >{validations.title}</span>
                  </Col>)}



                </Row>







              </Col>

              <Col xs={12} sm={12} className="mt-2">
                <div className="field-title">
                  Content<span style={{ color: '#FF4444' }}>*</span>
                </div>
                {mediumOption !== null && (mediumOption.value !== 'sms' && mediumOption.value !== 'app-notification') && (<ReactQuill theme="snow" value={contentValue} onChange={setContentValue} />)}
                {mediumOption !== null && (mediumOption.value === 'sms' || mediumOption.value === 'app-notification') && (
                  <textarea
                    type="text"
                    placeholder="Enter here"
                    className="input-field w-100"
                    value={contentValue}
                    onChange={(event) => {
                      setContentValue(event.target.value); // Update state with input value
                    }}
                  />
                )}
                <span className="field-error" >{validations.template}</span>

              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
    <ToastContainer position="top-end">
      <Toast
        className="d-inline-block m-1"
        bg={snackbarStatus === true ? "success" : "danger"}
        show={showSnackbar}
        onClose={handleSnackbarClose}
        delay={3000}
        autohide
      >
        <Toast.Body style={{ color: "#ffffff" }}>
          {snackbarMessage}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  </Container>);

}

